import React, { Component, Fragment } from "react";
import { Layout, Image, Dropdown, Menu } from 'antd';
import { WhatsAppOutlined, InstagramOutlined, FacebookOutlined, LinkedinOutlined, InstagramFilled, FacebookFilled, LinkedinFilled } from '@ant-design/icons';
import { Link } from "react-router-dom";

import osloPolicySummery from '../../assets/images/oslo-policy-summary.pdf'
import aiawPolicySummery from '../../assets/images/aiaw-policy-summary.pdf'

const { Footer } = Layout;

class footer extends Component {
    render() {
        return (
            <Fragment>
                <Footer className="footer pb-2 pt-5 text-center">
                    <div className="container">
                        <div className="social-links">
                            <ul>
                                {/* <li>
                                    <a href="https://wa.me/97142461442?text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Oslo%20Pet%20Insurance." target={'_blank'} rel="noreferrer">
                                        <WhatsAppOutlined className="text-white"/>
                                    </a>
                                </li> */}
                                <li>
                                    <a href="https://www.instagram.com/osloinsurance.pet/" target={'_blank'} rel="noreferrer">
                                        <InstagramOutlined className="text-white"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.facebook.com/osloinsurance/?ref=py_c" target={'_blank'} rel="noreferrer">
                                        <FacebookFilled className="text-white"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/in/oslo-insurance-pet-49ba26206/" target={'_blank'} rel="noreferrer">
                                        <LinkedinFilled className="text-white"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-nav">
                            <ul className="quick-links">
                                { /* Dropdown menu for Policy Summary (EN / AR) */ }
                                { /* Build menu once here so it's recreated cleanly each render */ }
                                { /* Using antd Menu for consistency with existing design system */ }
                                { /* Hover (and click for mobile) triggers */ }
                                { /* Download attribute hints browser to save file; target _blank retains current session */ }
                                { /* Accessible span acts as the trigger element */ }
                                { /* NOTE: Keep previous items order; we only replaced the single Policy Summary link */ }
                                <li>
                                    <Link to={"/faqs"}>FAQs</Link>
                                </li>
                                <li>
                                    <Link to={"/about_us"}>About Us</Link>
                                </li>
                                <li>
                                    <a href="https://osloinsurance.pet/blog/" target="_blank">Blog</a>
                                </li>
                                <li>
                                    <Link to={"/contact_us"}>Contacts</Link>
                                </li>
                                <li>
                                    <Link to={"/terms_of_use"}>Terms of Use</Link>
                                </li>
                                <li>
                                    <Link to={"/privacy_policy"}>Privacy Policy</Link>
                                </li>
                                <li>
                                    <Dropdown
                                        overlay={(
                                            <Menu>
                                                <Menu.Item key="policy-en">
                                                    <a href={osloPolicySummery} download target="_blank" rel="noreferrer">OSLO Policy Summary</a>
                                                </Menu.Item>
                                                <Menu.Item key="policy-ar">
                                                    <a href={aiawPolicySummery} download target="_blank" rel="noreferrer">AIAW Policy Summary</a>
                                                </Menu.Item>
                                            </Menu>
                                        )}
                                        trigger={['hover','click']}
                                        placement="topCenter"
                                    >
                                        <span className="policy-summary-trigger pointer">Policy Documents</span>
                                    </Dropdown>
                                </li>
                            </ul>
                        </div>
                        <div className="bottom-footer full-width mb-4 mt-4">
                                <p className="underwriter-text">The information contained in this website is for illustrative purposes only and coverage under any pet insurance policy is expressly subject to the terms and conditions of the policy documentation issued by the insurer. Coverage underwritten by Al-Ittihad Al-Watani (AIAW), registered under UAE Federal Law No. 6 of 2007 with Insurance Authority License No. 42 and Commercial License No. 200345 dated 21/11/1976. Live vet and Oslo pet cloud are separate non insurance services unaffiliated with AIAW.</p>
                                <a  href="https://www.alittihadalwatani.com/" target={'_blank'} rel="noreferrer" className="insurer-logo-holder">
                                    <img className="img-fluid" src="/images/al-ittihad-al-watani-blue.jpg" alt="Al-Ittihad Al-Watani (AIAW)"/>
                                </a>
                                <p className="mt-4">
                                © 2021 OSLO FZE, Dubai, United Arab Emirates - All Rights Reserved.
                                </p>
                        </div>
                    </div>
                </Footer>
            </Fragment>
        );
    }
}

export default footer;
